import { useQuery } from 'react-query';
import { ContractDocument } from 'shared/types';
import { useService } from 'shared/providers';
import {
  GetContractsForCustomerAndBrandProps,
  GetContractsForCustomerAndBrandsProps,
} from 'shared/services/contract-service';
export function useQueryContracts(props: GetContractsForCustomerAndBrandProps) {
  const { contractService } = useService();
  const { data, isLoading, isFetching } = useQuery<ContractDocument[], Error>(['contracts', props], () =>
    contractService.getContractsForCustomerAndBrand(props)
  );

  return { contracts: data, isLoading, isFetching } as const;
}

export function useQueryContractsByBrands(props: GetContractsForCustomerAndBrandsProps) {
  const { contractService } = useService();
  const { data, isLoading, isFetching } = useQuery<ContractDocument[], Error>(['contracts', props], () =>
    contractService.getContractsForCustomerAndBrands(props)
  );

  return { contracts: data, isLoading, isFetching } as const;
}
